const API_PRODUCTS =
  "/api/v1/Boomerang/GetPLPItems?userId={userId}&webstoreId={webstoreId}&mediaId={mediaId}";
const API_CATEGORIES = "/api/v1/Boomerang/{webStoreId}/category/list";

const fetchAPI = (path, body) => {
  const body_ = Object.assign(
    {
      page_size: 24,
    },
    body
  );
  const response = fetch(path, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body_),
  })
    .then((r) => {
      if (r.ok) {
        return r.json();
      } else {
        return r;
      }
    })
    .catch((e) => {
      return e;
    });

  return response;
};

const getUrlParams = () => {
  try {
    const url = window.location.href;
    let paramString = url.split("?")[1];
    let queryString = new URLSearchParams(paramString);
    const response = {};
    for (let pair of queryString.entries()) {
      switch (pair[0].toLowerCase()) {
        case "uid":
          response["uId"] = pair[1];
          break;
        case "wid":
          response["wId"] = pair[1];
          break;
        case "mid":
          response["mId"] = pair[1];
          break;
      }
    }

    return response;
  } catch (e) {
    return {};
  }
};

function detectDevice() {
  const w = window.innerWidth;
  if (w < 480) {
    return "MOBILE";
  }
  if (w < 1024 && w >= 480) {
    return "TABLET";
  }
  return "DESKTOP";
}

const getUserDetail = () => {
  return {
    host: window.location.host,
    pageUrl: window.document.location.href,
  };
};

export {
  fetchAPI,
  API_PRODUCTS,
  API_CATEGORIES,
  getUrlParams,
  detectDevice,
  getUserDetail,
};
